import VueRouter from 'vue-router';
import {isMobile} from '../util/helper';

const bkpDetailPC = () => import('../pages/agentBookkeeping.vue');
const bkpDetailMobile = () => import('../pages/mobile/agentBookkeeping.vue');
const crsDetailPC = () => import('../pages/crsDetail.vue');
const crsDetailMobile = () => import('../pages/mobile/crsDetail.vue');
const tms = () => import('../pages/tms.vue');
const orderBkpConfirm = () => import('../pages/order/bkpConfirm.vue');
const orderCrsConfirm = () => import('../pages/order/crsConfirm.vue');
const orderParkConfirm = () => import('../pages/order/parkConfirm.vue');
const orderPaySuccess = () => import('../components/order/paySuccess.vue');

const crsDetail = isMobile() ? crsDetailMobile : crsDetailPC;
const bkpDetail = isMobile() ? bkpDetailMobile : bkpDetailPC;

const href = window.location.href;
let home = tms;
if (href.indexOf('/product/bookkeeping') > -1) {
  home = bkpDetail;
} else if (href.indexOf('/product/crs') > -1) {
  home = crsDetail;
}

const routes = [
    {
        name: 'home',
        path: '/',
        component: home
    },
    {
        name: 'tms',
        path: '/tms',
        component: () => import('../pages/tms.vue')
    },
    {
        name: 'bla',
        path: '/bla',
        component: () => import('../pages/bla.vue')
    },
    {
        name: 'bookkeeping',
        path: '/bookkeeping',
        component: () => import('../pages/bookkeeping.vue')
    },
    {
        name: 'agentBookkeeping',
        path: '/bkp/detail',
        component: bkpDetail
    },
    {
        name: 'orderBkpConfirm',
        path: '/order/bkp/confirm',
        component: orderBkpConfirm
    },
    {
        name: 'orderCrsConfirm',
        path: '/order/crs/confirm',
        component: orderCrsConfirm
    },
    {
        name: 'orderParkConfirm',
        path: '/order/park/confirm',
        component: orderParkConfirm
    },
    {
        name: 'orderPaySuccess',
        path: '/order/pay/success',
        component: orderPaySuccess
    },
    {
        name: 'service',
        path: '/service',
        component: () => import('../pages/service.vue')
    },
    {
        name: 'crsDetail',
        path: '/crs/detail',
        component: crsDetail
    }
];

export default new VueRouter({
    routes
});